export const HANDLE_API_MESSAGE = "HANDLE_API_MESSAGE";
export const REMOVE_NOTIFICATION = "REMOVE_NOTIFICATION";
export const REMOVE_NOTIFICATION_BY_ID = "REMOVE_NOTIFICATION_BY_ID";
export const REMOVE_ALL_NOTIFICATIONS = "REMOVE_ALL_NOTIFICATIONS";

export const GET_ALL_ROLE = "GET_ALL_ROLE";
export const GET_ALL_USER = "GET_ALL_USER";
